import { z } from 'zod'
import { t } from 'i18next'
import {
  KmSchema,
  SignalSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'
import { Betriebsstellenart } from '../../../../types'

// Default constants
const DEFAULT_AUFTRAG_9_40 = {
  enabled: true,
  selector: '' as const,
  feld_9_43_zugmeldestelle: {
    art: '' as '' | Betriebsstellenart,
    name: ''
  },
  feld_9_44_zugmeldestelle: {
    art: '' as '' | Betriebsstellenart,
    name: ''
  },
  feld_9_47_type: '' as const,
  feld_9_47_1_km: '',
  feld_9_47_2_signal: '',
  feld_9_48_type: '' as const,
  feld_9_48_1_km: '',
  feld_9_48_2_signal: ''
}

const DEFAULT_AUFTRAG_9_67 = {
  enabled: false
}

const DEFAULT_AUFTRAG_9_68 = {
  enabled: false
}

const DEFAULT_AUFTRAG_9_70 = {
  enabled: false
}

const DEFAULT_AUFTRAG_9_75 = {
  enabled: false
}

const DEFAULT_BEFEHL_9_FORM = {
  auftrag_9_40: DEFAULT_AUFTRAG_9_40,
  auftrag_9_67: DEFAULT_AUFTRAG_9_67,
  auftrag_9_68: DEFAULT_AUFTRAG_9_68,
  auftrag_9_70: DEFAULT_AUFTRAG_9_70,
  auftrag_9_75: DEFAULT_AUFTRAG_9_75
}

// Schema definitions
const Auftrag9_40Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_9_40.enabled),
    selector: z
      .enum(['', 'in', 'zwischen'])
      .default(DEFAULT_AUFTRAG_9_40.selector),
    feld_9_43_zugmeldestelle: ZugmeldestelleSchema,
    feld_9_44_zugmeldestelle: ZugmeldestelleSchema,
    feld_9_47_type: z
      .enum(['', 'km', 'signal'])
      .default(DEFAULT_AUFTRAG_9_40.feld_9_47_type),
    feld_9_47_1_km: KmSchema,
    feld_9_47_2_signal: SignalSchema,
    feld_9_48_type: z
      .enum(['', 'km', 'signal'])
      .default(DEFAULT_AUFTRAG_9_40.feld_9_48_type),
    feld_9_48_1_km: KmSchema,
    feld_9_48_2_signal: SignalSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_9_40))

const Auftrag9_67Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_9_67.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_9_67))

const Auftrag9_68Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_9_68.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_9_68))

const Auftrag9_70Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_9_70.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_9_70))

const Auftrag9_75Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_9_75.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_9_75))

// Base schema
const Befehl9FormSchemaBase = z
  .object({
    auftrag_9_40: Auftrag9_40Schema,
    auftrag_9_67: Auftrag9_67Schema,
    auftrag_9_68: Auftrag9_68Schema,
    auftrag_9_70: Auftrag9_70Schema,
    auftrag_9_75: Auftrag9_75Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_9_FORM))

export const Befehl9FormSchema = Befehl9FormSchemaBase

// Validation schema
export const createBefehl9FormValidationSchema = () => {
  return Befehl9FormSchemaBase.refine(
    (data) => {
      return data.auftrag_9_67.enabled || data.auftrag_9_68.enabled
    },
    {
      message: t('ui-validation:befehl9.select_one')
    }
  )
}

export type Befehl9FormData = z.infer<typeof Befehl9FormSchemaBase>
